define('bizzabo/views/main/PollsView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/consts',
    'bizzabo/models/Poll',
    'bizzabo/views/main/MainView',
    'bizzabo/views/PollsCollectionView',
    'bizzabo/views/popup/AddPollView',
    'bizzabo/views/popup/ImagePreviewView',
    'hbars!bizzabo/templates/polls'
], function(
    $,
    Backbone,
    _,
    Global,
    Consts,
    Poll,
    MainView,
    PollsCollectionView,
    AddPollView,
    ImagePreviewView,
    pollsTemplate
    ) {

    var PollsView = MainView.extend({

        tabClass : Consts.UI.tabClasses.POLLS,

        prepare : function() {
            var eventId = this.model.get('id');
            var polls = Global.modelPool.getPolls(eventId);
            var servicePlan = Global.modelPool.getServicePlan(eventId);
            var agenda = Global.modelPool.getAgenda(eventId);
            var partners = Global.modelPool.getPartners(eventId);
            this.prepareModels([this.model, polls, servicePlan, agenda, partners]);
        },

        setQuestionsSelected : function(question) {
            this.$('.poll-question-name').toggleClass('answerSelected', false);
            question.$el.find('.poll-question-name').toggleClass('answerSelected', true);
        },

        render : function() {
            this.renderMainView({
                hasDetails : true,
                detailsSizeClass : 'width440 scrollable'
            });

            this.putContentView(new PollsContentView({
                model : this.model,
                pollsView : this
            }));
        },

        remove : function() {
            this.removeMainView();
        }
    });

    var PollsContentView = Backbone.View.extend({

        events : {
            'click .addPollButton': 'addPollButtonClicked',
            'click .getStartedButton': 'getStartedButtonClicked',
            'click .poll-intro-box': 'pollIntroBoxClicked',
            'click' : 'hideDropDown'
        },

        initialize : function(options) {
            this.pollsCollection = Global.modelPool.getPolls(this.model.get("id"));

            this.pollsCollectionView = new PollsCollectionView({
                model: this.pollsCollection,
                pollsView: this.options.pollsView
            });

            _.bindAll(this, 'errorReordering');

            this.listenTo(this.pollsCollection, 'add remove reset', this.renderIntroState);
            this.listenTo(Backbone, Consts.Notifications.mainPage.POLLS_PAGE_LOADED, this.onPageLoad);
        },

        remove: function() {
            return Backbone.View.prototype.remove.call(this);
        },

        renderIntroState : function() {
            var hasPolls = (this.pollsCollection.length > 0);
            this.$('.poll-intro').toggleClass('hide', hasPolls);
            this.$('.addPollButton').toggleClass('hide', !hasPolls);
        },

        addPollButtonClicked : function() {
            this.options.pollsView.hideDetails();
            var newModel = new Poll({eventId : this.pollsCollection.eventId});
            this.pollsCollection.add(newModel);
            new AddPollView({
                model : newModel
            }).show();

            window.scrollTo(0,document.body.scrollHeight);
        },

        pollIntroBoxClicked : function(e) {
            var image = $(e.currentTarget).attr('data-image');
            var imageModel = new Backbone.Model({
                src : image
            });
            new ImagePreviewView({
                model : imageModel
            }).show();
        },

        getStartedButtonClicked : function(e) {
            var servicePlan = Global.modelPool.getServicePlan(this.model.get('id'));
            if (servicePlan.hasFeature('polls')) {
                e.preventDefault();
                this.addPollButtonClicked();
            }
        },

        formDragFinished : function(modelCid, index) {
            var model = this.pollsCollection.get(modelCid);
            this.pollsCollection.remove(model, {
                silent : true
            });
            this.pollsCollection.add(model, {
                silent : true,
                at : index
            });

            this.pollsCollection.updatePollsOrder({error: this.errorReordering});
        },

        errorReordering : function() {
            this.$( ".pollsList" ).sortable( "cancel" );
            this.pollsCollection.remove(this.modelLastPollDragged, {
                silent : true
            });
            this.pollsCollection.add(this.modelLastPollDragged, {
                silent : true,
                at : this.indexLastPollDragged
            });
        },

        hideDropDown : function(e) {
            if (!$(e.target).hasClass('poll-setting-menu-button')) {
                this.$('.poll-setting-dropdown').toggleClass('poll-setting-dropdown-visible', false);

                //timeout for the fadeout animation
                setTimeout(function(){
                    this.$('.poll-setting-dropdown').toggleClass('hide', true);
                }, 500);
                this.$('.poll-setting-menu-button'). toggleClass('poll-setting-menu-button-clicked', false);
            }
        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent() && Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('.addPollButton').toggleClass('hide', true);
                this.$(".pollsList").sortable('disable');
            } else {
                this.renderIntroState();
                this.renderSortable();
                this.$(".pollsList").sortable('enable');
            }
        },

        renderSortable : function() {
            var containerEl = this.$(".pollsList");
            var thisView = this;
            containerEl.sortable({
                delay: 150,
                axis: 'y',
                handle: '.single-poll-drag',

                start : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    thisView.indexLastPollDragged = ui.item.index();
                    thisView.modelLastPollDragged = thisView.pollsCollection.get(cid);
                },

                stop : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    var index = ui.item.index();
                    thisView.formDragFinished(cid, index);
                }
            });
        },

        render : function() {
            var servicePlan = Global.modelPool.getServicePlan(this.model.get('id'));
            var source = _.extend(this.model.toJSON(), {
                hasPollsFeature: servicePlan.hasFeature('polls'),
                upgradeUrlQuery: servicePlan.upgradeUrlQuery(this.model),
                hasPolls: this.pollsCollection.length > 0,
                hasPollsBundle: this.hasPollsBundle
            });
            var html = pollsTemplate(source);
            this.$el.html(html);
            this.pollsCollectionView.setElement(this.$('.pollsList'));
            this.renderSortable();
            this.disableViewIfNeed();
            return this;
        },

        onPageLoad : function() {
            this.pollsCollectionView.render();
            this.pollsCollection.validate();
            this.listenTo(Global.modelPool.getActiveEvent(), 'change:event-is-active', this.disableViewIfNeed);
        }
    });

    return PollsView;
    
});
